import $http from '../../axios';
import {Notification} from "element-ui";

export async function fetchAccountReportResultEri({ state, commit }) {
    await $http
        .get("/api/reporte-resultado-integral-eri", { params : state.params})
        .then(response => {
            commit("setAccountReportResultEri", response.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("modelError", error.message);
        });
}

export async function fetchcost_center_1({ commit, state }) {
    await $http
        .get("/api/parametros-por-codigo/038")
        .then(response => {
        commit("setcost_center_1", response.data.data);
        })
        .catch(error => {
        Notification.error({
            title: "Error!",
            message: error.message,
            type: "error",
            duration: 1500,
            customClass: "notification-box"
        });
        commit("modelError", error.message);
        });
}


// WEBPACK FOOTER //
// ./src/modules/report-reult-eri/actions.js